/* components/patterns/SupportButton.jsx — «Поддержка» в правом кластере шапки,
   рядом с хабом обучения и колоколом. Переход на /support.

   Раньше вход был пунктом в меню пользователя внизу сайдбара — то есть за двумя
   кликами и там, где его никто не искал. Здесь он на виду и в одном ряду с
   остальными «служебными» иконками раздела.

   Не показывается: на самой /support (по аналогии с колоколом на /notifications
   — иначе кнопка ведёт на страницу, где ты уже стоишь) и на xs, где в шапке
   тесно: там вход пунктом «Поддержка» в шторке «Ещё».

   Бейдж — число ЗАЯВОК с непрочитанным ответом, зеркало колокола. Считаем заявки,
   а не сообщения: пользователь открывает тикет и прочитывает переписку целиком,
   поэтому «3» значит «в трёх заявках вам ответили». По сообщениям один
   разговорчивый оператор накручивал бы счётчик, не сообщая ничего сверх «есть
   ответ». */

import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { getSupportUnread } from '../../lib/api/support.js';
import { RR } from '../../lib/router.jsx';

const { useEffect, useState } = React;
const { useNavigate, useLocation } = RR;

const POLL_MS = 30000;          // та же кадансировка, что у уведомлений

/* Общий стор на модуль, а не состояние компонента: SupportButton рендерится и из
   PageHeader, и из ChatHeader, и два независимых интервала опрашивали бы бэкенд
   вдвое чаще без всякой пользы. Рефкаунт гасит интервал, когда кнопок на экране
   не осталось. */
let count = 0;
let timer = null;
let subs = new Set();

function emit() { subs.forEach((fn) => fn(count)); }

function fetchNow() {
  return getSupportUnread()
    .then((res) => {
      // Ошибку глотаем намеренно: бейдж — украшение шапки, и упавший счётчик не
      // повод показывать пользователю сбой. Следующий тик попробует снова.
      if (!res || !res.ok || !res.data) return;
      const n = Number(res.data.unread_count) || 0;
      if (n !== count) { count = n; emit(); }
    })
    .catch(() => { /* см. выше */ });
}

function subscribe(fn) {
  subs.add(fn);
  if (subs.size === 1) {
    fetchNow();
    timer = setInterval(fetchNow, POLL_MS);
  } else {
    fn(count);
  }
  return () => {
    subs.delete(fn);
    if (subs.size === 0 && timer) { clearInterval(timer); timer = null; }
  };
}

function useSupportUnread(pathname) {
  const [n, setN] = useState(count);
  useEffect(() => subscribe(setN), []);
  // Ушли со страницы поддержки — там ответы только что прочитались, и ждать
  // тридцать секунд, пока бейдж догонит реальность, значит показывать неправду.
  useEffect(() => { if (pathname !== '/support') fetchNow(); }, [pathname]);
  return n;
}

function SupportButton({ bp }) {
  const navigate = useNavigate();
  const location = useLocation();
  const n = useSupportUnread(location.pathname);
  if (bp === 'xs') return null;
  if (location.pathname === '/support') return null;
  const label = n > 0 ? `Поддержка, непрочитанных ответов: ${n}` : 'Поддержка';
  return (
    <button type="button" className="support-trigger" aria-label={label}
      title={label} onClick={() => navigate('/support')}>
      <Icon name="headset" size={18} />
      {n > 0 && <span className="bell-badge num" aria-hidden="true">{n > 9 ? '9+' : n}</span>}
      <span className="visually-hidden" aria-live="polite">
        {n > 0 ? `Непрочитанных ответов поддержки: ${n}` : ''}
      </span>
    </button>
  );
}

export { SupportButton };
